import { NotFound } from "../../components/error";

const ScreensError = () => (
  <div data-test="component-app">
    <NotFound data-test="not-found" />
  </div>
);

export default ScreensError;
